import { ApiSupportSelector } from "../../../helpers/apiSupport"
import { InitialState } from "../reducers"

export const Selector = {
    get: (state): InitialState => {
        return state.inventory.configuration
    },

    getCostMethod: (state) => {
        return Selector.get(state).costMethod
    },

    isEnabled: (state) => {
        return Selector.get(state).enabled
    },

    isEnabledAndLoaded: (state) => {
        return {
            isEnabled: Selector.get(state).enabled,
            isLoaded: Selector.get(state).isLoaded,
            isLoading: Selector.get(state).isLoading
        }
    },


    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/selectors/selectors.ts